/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Payment_Method_CashInputs */

const vi_expense_payment_method_cash = /** @type {(inputs: Expense_Payment_Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền mặt`)
};

/**

* @param {Expense_Payment_Method_CashInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_payment_method_cash = /** @type {((inputs?: Expense_Payment_Method_CashInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Payment_Method_CashInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_payment_method_cash(inputs)
});